// Partner hub - talks to the partnerHub Cloud Function (Paul, 18 Oct 2026).
// On localhost it uses the local Functions emulator; "?as=<test id>" there plays as a test person
// without signing in (only the emulator accepts it). Test ids starting "free" are non-members.
import { firebase } from "../../firebase/config";

const isLocal = typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
export const PH_URL = isLocal
  ? "http://127.0.0.1:5001/bridgechampions/us-central1/partnerHub"
  : "https://us-central1-bridgechampions.cloudfunctions.net/partnerHub";

export function testUid() {
  if (!isLocal) return null;
  try {
    const q = new URLSearchParams(window.location.search).get("as");
    if (q) sessionStorage.setItem("ph-as", q);
    return sessionStorage.getItem("ph-as");
  } catch (e) {
    return null;
  }
}

async function headers(anon = false) {
  const h = { "Content-Type": "application/json" };
  const as = testUid();
  if (as) {
    h["X-Test-Uid"] = as;
    return h;
  }
  const user = firebase.auth().currentUser;
  if (!user && anon) return h;
  if (!user) throw new Error("Please sign in.");
  h.Authorization = `Bearer ${await user.getIdToken()}`;
  return h;
}

export async function ph(action, args = {}, { signal, anon } = {}) {
  const h = await headers(anon);
  let r;
  try {
    r = await fetch(PH_URL, { method: "POST", headers: h, body: JSON.stringify({ action, ...args }), signal });
  } catch (e) {
    if (e && e.name === "AbortError") throw e;
    const err = new Error("Couldn't reach the server. Check your connection.");
    err.network = true;
    throw err;
  }
  const j = await r.json().catch(() => ({}));
  if (!j.ok) throw new Error(j.error || "Something went wrong. Please try again.");
  return j;
}

// Leaving the table page: tell the server, even as the tab closes.
export async function phAway(pairId) {
  try {
    const h = await headers();
    fetch(PH_URL, { method: "POST", headers: h, body: JSON.stringify({ action: "away", pairId }), keepalive: true }).catch(() => {});
  } catch (e) {
    /* signed out */
  }
}

// An invite code opened while signed out is remembered, so it is used after sign-in or sign-up.
const PENDING = "ph-join-code";
export const rememberCode = (code) => { try { localStorage.setItem(PENDING, code); } catch (e) { /* storage blocked */ } };
export const takeRememberedCode = () => {
  try {
    const c = localStorage.getItem(PENDING);
    if (c) localStorage.removeItem(PENDING);
    return c;
  } catch (e) {
    return null;
  }
};
